import { Image } from '@jfs/ui-new'
import React, { useEffect } from 'react'

const Rsil = () => {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = 'rel_logo.ico'
  })
  return (
    <Image height={'100vh'} width={'100vw'} resizeMode="stretch" source={require('../../assets/images/rsil.png')} />
  )
}

export default Rsil
